/**
 * Firebase-related constants
 */

// Firebase collection root
export const FIREBASE_ROOT_COLLECTION = 'root';

// Subcollections
export const PLAYERS_COLLECTION = 'players';
export const TURNS_COLLECTION = 'turns';
